// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBCBY291WWa5BYnM_J_yZGAt9LBTS30Uto",
  authDomain: "oscar-udhaar-edeaf.firebaseapp.com",
  databaseURL: "https://oscar-udhaar-edeaf.firebaseio.com",
  projectId: "oscar-udhaar-edeaf",
  storageBucket: "oscar-udhaar-edeaf.appspot.com",
  messagingSenderId: "298615079533",
  appId: "1:298615079533:web:3e3a264144c6a9a23a3564",
  measurementId: "G-SHYGKR3WQM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);